"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var GMapsToWTBAddress = function GMapsToWTBAddress(address) {
  var fieldInfo = {};

  if (address.structured_formatting) {
    fieldInfo.street = address.structured_formatting.main_text;
  } else {
    fieldInfo.street = null;
  }

  if (address.post_code && address.post_code !== '') {
    fieldInfo.zipCode = address.post_code;
  } else {
    fieldInfo.zipCode = null;
  }

  if (address.terms) {
    var _address$terms, _address$terms2;

    fieldInfo.country = (_address$terms = address.terms[address.terms.length - 1]) === null || _address$terms === void 0 ? void 0 : _address$terms.value;
    fieldInfo.city = (_address$terms2 = address.terms[address.terms.length - 2]) === null || _address$terms2 === void 0 ? void 0 : _address$terms2.value;
  } else {
    fieldInfo.country = null;
    fieldInfo.city = null;
  }

  return fieldInfo;
};

var _default = GMapsToWTBAddress;
exports["default"] = _default;